import request from '../utils/request';

export async function getWorkOrders(params: any) {
  const resp = await request.get('/api/v1/workorders/workorders/', { params });
  return resp?.data;
}

export async function getWorkOrderById(id: number | string) {
  const resp = await request.get(`/api/v1/workorders/workorders/${id}/`);
  return resp?.data;
}

export async function acceptWorkOrder(id: number | string) {
  const resp = await request.post(`/api/v1/workorders/workorders/${id}/accept/`);
  return resp?.data;
}

export async function startWorkOrder(id: number | string) {
  const resp = await request.post(`/api/v1/workorders/workorders/${id}/start/`);
  return resp?.data;
}

export async function completeWorkOrder(id: number | string) {
  const resp = await request.post(`/api/v1/workorders/workorders/${id}/complete/`);
  return resp?.data;
}

export async function doneChecklistItem(id: number | string) {
  const resp = await request.post(`/api/v1/workorders/workorder-checklist/${id}/done/`);
  return resp?.data;
}

// Templates
export async function getWorkOrderTemplates(params?: any) {
  const resp = await request.get('/api/v1/workorders/workorder-templates/', { params });
  return resp?.data;
}

export async function getWorkOrderTemplateById(id: number | string) {
  const resp = await request.get(`/api/v1/workorders/workorder-templates/${id}/`);
  return resp?.data;
}

export async function createWorkOrderTemplate(payload: any) {
  const resp = await request.post('/api/v1/workorders/workorder-templates/', payload);
  return resp?.data;
}

export async function updateWorkOrderTemplate(id: number | string, payload: any) {
  const resp = await request.patch(`/api/v1/workorders/workorder-templates/${id}/`, payload);
  return resp?.data;
}


